import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      Cloudflare Demo Environment &mdash; Internal use only &mdash;{' '}
      <a href="https://dash.cloudflare.com" target="_blank" rel="noreferrer">
        Cloudflare Dashboard
      </a>
    </footer>
  );
}
